import React from "react";
import ReactDOM from "react-dom/client";
import UserApp from "@/user/UserApp";
import './index.css';
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter } from "react-router-dom";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <UserApp />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);